import { combineReducers } from '@reduxjs/toolkit';
import { userIdentificationsReducer } from './reducers/user-identifications-reducer';
import { applicationsListReducer } from './reducers/applications-list-reducer';
import { clientScopesReducer } from './reducers/client-scopes-reducer';
import { apiKeysListReducer } from './reducers/api-keys-list-reducer';
import type { IIdentificationState } from './interfaces';

export default combineReducers<IIdentificationState>({
  userIdentificationsReducer,
  applicationsListReducer,
  clientScopesReducer,
  apiKeysListReducer,
});
